import Image from "next/image";
import { Quote } from "lucide-react";

interface TestimonialProps {
    testimonial: string;
    user: string;
    username: string;
    rating: number;
}

export default function TestimonialCard({ testimonial, user, username }: TestimonialProps) {
    return (
        <div className="
            relative flex flex-col items-center justify-between
            w-full max-w-[300px]
            h-auto sm:h-[350px]
            p-4 sm:p-6
            bg-darkGrey overflow-hidden
        ">

            <Quote 
                className="
                    absolute top-3 left-3
                    w-10 h-10 sm:w-12 sm:h-12
                    text-secondary/30 rotate-180 z-0
                "
                strokeWidth={1.5} 
            />

            <p className="
                text-sm sm:text-[16px]
                relative z-10
                text-gray-800
                mt-12 sm:mt-16
                px-2 sm:px-4
                text-center sm:text-left
            ">
                {testimonial}
            </p>
            
            <div className="
                flex items-center gap-3
                z-10 pb-1
                w-full
                px-2 sm:px-4
                justify-center sm:justify-start
            ">
                <div className="relative w-8 h-8 sm:w-9 sm:h-9">
                    <Image
                        src={user}
                        alt="support-image"
                        fill
                        priority
                        className="rounded-full object-cover"
                    />
                </div>
                <p className="relative text-black text-sm sm:text-[16px]">
                    {username}
                </p>
            </div>
            
        </div>
    );
}
